import { v4 as uuidv4 } from "uuid";

const SESSION_KEY = "biodataForm";
const LANG_KEY = "create_shaadi_biodata_language";

/**
 * Initialize the session with a UUID and empty form data if not already present.
 */
export const initializeSession = (initialFormData, uuid) => {
  const savedData = localStorage.getItem(SESSION_KEY);
  if (savedData) {
    const parsedData = JSON.parse(savedData);
    return parsedData;
  } else {
    const newUUID = uuid ? uuid : uuidv4(); // Generate a new UUID
    const newSessionData = { uuid: newUUID, formData: initialFormData };
    localStorage.setItem(SESSION_KEY, JSON.stringify(newSessionData)); // Save to localStorage
    return newSessionData;
  }
};

/**
 * Save form data to session storage.
 * @param {Object} formData - The current form data to save.
 */
export const saveFormDataToSession = (formData) => {
  const savedData = localStorage.getItem(SESSION_KEY);
  const sessionData = savedData ? JSON.parse(savedData) : {};
  const updatedSessionData = { ...sessionData, formData };
  localStorage.setItem(SESSION_KEY, JSON.stringify(updatedSessionData)); // Save to localStorage
};

/**
 * Retrieve saved form data from session storage.
 */
export const getSavedFormData = (initialFormData) => {
  const savedData = localStorage.getItem(SESSION_KEY);
  return savedData ? JSON.parse(savedData)?.formData : initialFormData;
};

/**
 * Set UUID from external source (e.g., query parameter)
 */
export const setUuid = (uuid, initialFormData) => {
  const savedData = localStorage.getItem(SESSION_KEY);
  const sessionData = savedData ? JSON.parse(savedData) : {};
  const updatedSessionData = { ...sessionData, uuid, formData: sessionData.formData || initialFormData };
  localStorage.setItem(SESSION_KEY, JSON.stringify(updatedSessionData));
  return uuid;
};

/**
 * Retrieve the UUID from session storage or generate a new one.
 */
export const getUuid = (initialFormData) => {
  const savedData = localStorage.getItem(SESSION_KEY);
  if (savedData) {
    const parsedData = JSON.parse(savedData);
    if (parsedData.uuid) { // Check if uuid exists and is valid
      return parsedData.uuid;
    } else {
      const newUUID = uuidv4();
      const sessionData = { uuid: newUUID, formData: parsedData.formData || initialFormData };
      localStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
      return newUUID;
    }
  } else {
    const newUUID = uuidv4();
    const newSessionData = { uuid: newUUID, formData: initialFormData };
    localStorage.setItem(SESSION_KEY, JSON.stringify(newSessionData)); // Ensure UUID is stored
    return newUUID;
  }
};

/**
 * Set the selected language in localStorage.
 */
export const setLang = (language) => {
  localStorage.setItem(LANG_KEY, language);
};

/**
 * Get the selected language from localStorage.
 */
export const getLang = () => {
  return localStorage.getItem(LANG_KEY);
};